import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { z } from "@/shared/zod";
import { wsdotHighwayAlertsApiMeta } from "../apiMeta";
import {
  type EventCategoriesInput,
  eventCategoriesInputSchema,
} from "./shared/eventCategories.input";

/**
 * Metadata for the fetchEventCategories endpoint
 */
export const eventCategoriesMeta = {
  functionName: "fetchEventCategories",
  endpoint: "/getEventCategoriesAsJson",
  inputSchema: eventCategoriesInputSchema,
  outputSchema: z.string().array(),
  sampleParams: {},
  endpointDescription:
    "List all available event category names for filtering alerts.",
} satisfies EndpointMeta<EventCategoriesInput, string[]>;

const { fetch, useHook } = createFetchAndHook<EventCategoriesInput, string[]>({
  api: wsdotHighwayAlertsApiMeta,
  endpoint: eventCategoriesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/eventCategories.endpoints").eventCategoriesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving all available event category names for filtering alerts
 */
export const fetchEventCategories: FetchFactory<
  EventCategoriesInput,
  string[]
> = fetch;

/**
 * React Query hook for retrieving all available event category names for filtering alerts
 */
export const useEventCategories: HookFactory<EventCategoriesInput, string[]> =
  useHook;
